import { useRef } from 'react';
import XTable from 'components/XTable';
import { DatePicker, Select } from 'antd';
import { getStatics, getDownloadStaticsCheckApi } from 'api/checkInRecord';
import moment from 'moment';
import { applyTypes } from 'enumeration/applyTypes';
import { downFile } from 'utils';
const { Option } = Select;
const CheckStatistics = () => {
    const xTableRef = useRef();

    const queryItems = [
        {
            formItemApis: {
                label: '查询日期',
                help: null,
                name: 'visitDateRange',
            },
            item: <DatePicker format="YYYY-MM-DD" />,
        },
        {
            formItemApis: {
                label: '入住类别',
                help: null,
                name: 'applyType',
            },
            item: (
                <Select style={{ width: 150 }} placeholder="请选择" allowClear>
                    {applyTypes.map(({ value, text }) => {
                        return (
                            <Option key={value} value={value}>
                                {text}
                            </Option>
                        );
                    })}
                </Select>
            ),
        },
    ];

    const columns = [
        {
            title: '申请年龄段',
            dataIndex: 'ageGroup',
        },
        {
            title: '性别',
            dataIndex: 'sex',
            children: [
                {
                    title: '男',
                    dataIndex: 'female',
                    key: 'female',
                },
                {
                    title: '女',
                    dataIndex: 'male',
                    key: 'male',
                },
            ],
        },
        {
            title: '护理区域',
            dataIndex: 'nursing_area',
            children: [
                {
                    title: '自理区',
                    dataIndex: 'self',
                    key: 'self',
                },
                {
                    title: '半自理',
                    dataIndex: 'half',
                    key: 'half',
                },
                {
                    title: '全护理',
                    dataIndex: 'full',
                    key: 'full',
                },
            ],
        },
        {
            title: '身份类型',
            dataIndex: 'identity',
            children: [
                {
                    title: '公费',
                    dataIndex: 'freePay',
                    key: 'freePay',
                },
                {
                    title: '自费',
                    dataIndex: 'selfPay',
                    key: 'selfPay',
                },
            ],
        },
        {
            title: '在院人数',
            dataIndex: 'checkIn',
        },
    ];
    const downloadRecord = () => {
        const queryValue = xTableRef.current.queryForm?.getFieldsValue();
        const params = handelParams(queryValue);
        params.status = true;
        getDownloadStaticsCheckApi(params).then(res => {
            if (res.success) {
                const filename = `福州社会福利院入住人员统计表${moment().valueOf()}.xls`;
                downFile(res.file, filename);
            }
        });
    };

    const actionBtns = [{ text: '导出', onClick: downloadRecord }];

    const handelParams = params => {
        const { visitDateRange, ...otherParams } = params;
        console.log(visitDateRange);
        let beginDate = '';
        let newParams = otherParams;
        // if (visitDateRange && visitDateRange.length) {
        beginDate = moment(visitDateRange).format('YYYY-MM-DD');
        // endDate = moment(visitDateRange[1]).format('YYYY-MM-DD');
        newParams = { ...otherParams, beginDate };
        // }
        return newParams;
    };

    return (
        <div>
            <XTable
                columns={columns}
                queryItems={queryItems}
                handelParams={handelParams}
                api={getStatics}
                apiParams={{ status: true }}
                actionBtns={actionBtns}
                pagination={false}
                ref={xTableRef}
            />
        </div>
    );
};
export default CheckStatistics;
